/** @format */

export const environment = {
	production: false,
	apiUrl: "https://api-smartforms-dev.smssoftwarestudio.com/api",
	microsoftRedirectUrl: "https://api-smartforms-dev.smssoftwarestudio.com/api/cloudintegrations/auth/callback",
	idleTime: 600,
  timeUntilIdle: 5,
	keycloak: {
    url: "https://auth.smssoftwarestudio.com/",
    realm: "leads-dev",
    clientId: "smart-forms",
    backendClientId: "smart-forms-api",
  },
}
